var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A202C",
    d: "M9 3.419v2.58h6c.553 0 1 .449 1 1.001v12c0 .552-.447 1-1 1H1c-.553 0-1-.448-1-1V7c0-.552.447-1 1-1h6V3.416L5.87 4.545c-.386.387-1.014.387-1.407-.007-.391-.39-.388-1.025-.007-1.407L7.298.29C7.49.097 7.742 0 7.995 0l.008.004c.254 0 .506.095.696.286L11.54 3.13c.387.387.387 1.015-.005 1.407-.391.391-1.027.388-1.409.007L9 3.419zM7 8V6H3c.552 0 1 .448 1 1s-.448 1-1 1h4zm2 0h5V6H9v2zM7 8H2v10h12V8H9v5.002c0 .551-.444.998-1 .998-.552 0-1-.448-1-.998V8zm7 0h-1c-.552 0-1-.448-1-1s.448-1 1-1h1v2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareDark);
export default __webpack_public_path__ + "static/media/share-dark.76fd013d.svg";
export { ForwardRef as ReactComponent };